import React, { useContext, useEffect, useState } from "react";
import { TextField, MenuItem, Button } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function GuarantorDetails({ formData }) {
  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);

  const [formDatas, setFormDatas] = useState({
    first_name:  "",
    middle_name:  "",
    surname:  "",
    date_of_birth:  "",
    gender: "",
    phone_no_1: "",
    phone_no_2:  "",
    marital_status:  "",
    email:  "",
    psn_no: "",
    mother_maiden_name:  "",
    account_name:  "",
    account_number:  "",
    bvn:  "",
    nin_number:  "",
    bank_name: "",
    tin_number:  "",
    home_address:  "",
    office_address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prev) => ({ ...prev, [name]: value }));
  };

  const validateField = (type, value) => {
    if (type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value.trim());
    }

    const numericFields = [
      "phone_no_1",
      "phone_no_2",
      "psn_no",
      "account_number",
      "bvn",
      "nin_number",
      "tin_number",
    ];
    if (numericFields.includes(type)) {
      return /^\d{1,15}$/.test(value.trim());
    }

    return value.trim() !== "";
  };

  const handleSubmit =async (type) => {
    if (!validateField(type, formDatas[type])) {
      SoundAlert("error");
      if (type === "email") toast.error("Please enter a valid email address.");
      else if (
        ["phone_no_1", "phone_no_2", "psn_no", "account_number", "bvn", "nin_number", "tin_number"].includes(type)
      )
        toast.error("Must be numbers only (max 15 digits).");
      else toast.error("Please fill in this field.");
      return;
    }



      const response = await Putrequest("auth/update_guarantor_details",{...formDatas,user_token:UserTokens})
           
                       
                           if(response.status){
        
                            SoundAlert("success")
                            toast.success(response.textStatus)
                            setReloadBioForms(!ReloadBioForms)
        
                              }else  if(!response.status){
        
                            SoundAlert("error")
                            toast.success(response.textStatus)
                            setReloadBioForms(!ReloadBioForms)
        
                              }


  
  };


  


    useEffect(()=>{
    
           setFormDatas({
          first_name: formData.guarantor_details.first_name || "",
          middle_name: formData.guarantor_details.middle_name || "",
          surname: formData.guarantor_details.surname || "",
          date_of_birth: formData.guarantor_details.date_of_birth || "",
          gender: formData.guarantor_details.gender || "",
          phone_no_1: formData.guarantor_details.phone_no_1 || "",
          phone_no_2: formData.guarantor_details.phone_no_2 || "",
          marital_status: formData.guarantor_details.marital_status || "",
          email: formData.guarantor_details.email || "",
          psn_no: formData.guarantor_details.psn_no || "",
          mother_maiden_name: formData.guarantor_details.mother_maiden_name || "",
          account_name: formData.guarantor_details.account_name || "",
          account_number: formData.guarantor_details.account_number || "",
          bvn: formData.guarantor_details.bvn || "",
          nin_number: formData.guarantor_details.nin_number || "",
          bank_name: formData.guarantor_details.bank_name || "",
          tin_number: formData.guarantor_details.tin_number || "",
          home_address: formData.guarantor_details.home_address || "",
          office_address: formData.guarantor_details.office_address || "",
           })
    
    },[formData])




  return (
    <div className="pt-2 pb-2">

      {/* First Name */}
      <TextField
        label="First Name"
        name="first_name"
        value={formDatas.first_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("first_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Middle Name */}
      <TextField
        label="Middle Name"
        name="middle_name"
        value={formDatas.middle_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("middle_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Surname */}
      <TextField
        label="Surname"
        name="surname"
        value={formDatas.surname}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("surname")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Date of Birth */}
      <p className="pt-1 pb-1 font-extrabold">Date of Birth</p>
      <TextField
        name="date_of_birth"
        type="date"
        value={formDatas.date_of_birth}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("date_of_birth")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Gender */}
      <TextField
        select
        label="Gender"
        name="gender"
        value={formDatas.gender}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("gender")}>
              Save
            </Button>
          ),
        }}
      >
        <MenuItem value="Male">Male</MenuItem>
        <MenuItem value="Female">Female</MenuItem>
      </TextField>

      {/* Phone No 1 */}
      <TextField
        label="Phone No. 1"
        name="phone_no_1"
        value={formDatas.phone_no_1}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
          inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("phone_no_1")}>
              Save
            </Button>
          ),
        
        }}
      />

      {/* Phone No 2 */}
      <TextField
        label="Phone No. 2"
        name="phone_no_2"
        value={formDatas.phone_no_2}
        onChange={handleChange}
        fullWidth
        margin="dense"
         inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("phone_no_2")}>
              Save
            </Button>
          ),
         
        }}
      />

      {/* Marital Status */}
      <TextField
        select
        label="Marital Status"
        name="marital_status"
        value={formDatas.marital_status}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("marital_status")}>
              Save
            </Button>
          ),
        }}
      >
        <MenuItem value="Single">Single</MenuItem>
        <MenuItem value="Married">Married</MenuItem>
        <MenuItem value="Divorced">Divorced</MenuItem>
        <MenuItem value="Widowed">Widowed</MenuItem>
      </TextField>

      {/* Email */}
      <TextField
        label="Email"
        name="email"
        value={formDatas.email}
        onChange={handleChange}
        type="email"
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("email")}>
              Save
            </Button>
          ),
        }}
      />

      {/* PSN No */}
      <TextField
        label="PSN No"
        name="psn_no"
        value={formDatas.psn_no}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("psn_no")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Mother Maiden Name */}
      <TextField
        label="Mother Maiden Name"
        name="mother_maiden_name"
        value={formDatas.mother_maiden_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("mother_maiden_name")}>
              Save
            </Button>
          ),
        }}
      />

      
      {/* Bank Name */}
      <TextField
        label="Bank Name"
        name="bank_name"
        value={formDatas.bank_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("bank_name")}>
              Save
            </Button>
          ),
        }}
      />



      {/* Account Name */}
      <TextField
        label="Account Name"
        name="account_name"
        value={formDatas.account_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("account_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Account Number */}
      <TextField
        label="Account Number"
        name="account_number"
        value={formDatas.account_number}
        onChange={handleChange}
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("account_number")}>
              Save
            </Button>
          ),
        }}
      />

      {/* BVN */}
      <TextField
        label="BVN"
        name="bvn"
        value={formDatas.bvn}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
         inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("bvn")}>
              Save
            </Button>
          ),
          
        }}
      />

      {/* NIN Number */}
      <TextField
        label="NIN Number"
        name="nin_number"
        value={formDatas.nin_number}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("nin_number")}>
              Save
            </Button>
          ),
         
        }}
      />

      {/* TIN Number */}
      <TextField
        label="TIN Number Optional"
        name="tin_number"
        value={formDatas.tin_number}
        onChange={handleChange}
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        fullWidth
        margin="dense"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("tin_number")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Home Address */}
      <TextField
        label="Home Address"
        name="home_address"
        value={formDatas.home_address}
        onChange={handleChange}
        fullWidth
        margin="dense"
        multiline
        rows={3}
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("home_address")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Office/Business Address */}
      <TextField
        label="Office/Business Address"
        name="office_address"
        value={formDatas.office_address}
        onChange={handleChange}
        fullWidth
        margin="dense"
        multiline
        rows={3}
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("office_address")}>
              Save
            </Button>
          ),
        }}
      />

    </div>
  );
}

export default GuarantorDetails;
